
const router = new Navigo(null);

export default router;
